//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.type

import com.apollographql.apollo.api.CompiledArgumentDefinition
import com.apollographql.apollo.api.Fragment
import com.apollographql.apollo.api.ObjectType

public class Query {
  public interface Data : Fragment.Data

  public companion object {
    public val __llm_query: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("query").build()

    public val __llm_langFromIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langFromIso3").build()

    public val __llm_langToIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langToIso3").build()

    public val __panlex_query: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("query").build()

    public val __panlex_langFromIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langFromIso3").build()

    public val __panlex_langToIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langToIso3").build()

    public val __suggestions_query: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("query").build()

    public val __suggestions_langFromIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langFromIso3").build()

    public val __suggestions_langToIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langToIso3").build()

    public val __translate_texts: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("texts").build()

    public val __translate_langFromIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langFromIso3").build()

    public val __translate_langToIso3: CompiledArgumentDefinition =
        CompiledArgumentDefinition.Builder("langToIso3").build()

    public val type: ObjectType = ObjectType.Builder(name = "Query").build()
  }
}
